
export interface DataArchivalConfiguration {
    disabled: boolean;
    archiveFrequencyInSec: number;
}